import { ComponentDataDestService } from '../component-data-dest.service';
import { catchError, map, tap } from 'rxjs';
import { Room } from '../../../models/location/Room.model';
import { ComponentDataSourceService } from '../../component-data-source/component-data-source.service';
import { environment } from '../../../environment/environment';
import { notifyDunaLocationsAdminFormSuccess, refreshAllLocationTableStores } from './location-stores-refresh';

export function add_room(
  componentDataDestService: ComponentDataDestService,
  componentDataSourceService: ComponentDataSourceService,
  data: any
) {
  const roomModel = new Room(
    '',
    data.room_name,
    data.location_guid,
    Number(data.capacity),
    data.description || ''
  );
  const dto = Room.toDTO(roomModel);
  const room = {
    guid: dto.guid,
    room_name: dto.room_name,
    location_guid: dto.location_guid,
    capacity: dto.capacity,
    description: dto.description
  };

  const request$ = componentDataDestService.http
    .post(`${environment.apiUrl}/locations/rooms`, { room })
    .pipe(
      catchError((error) => {
        console.error('[add_room] Error:', error);
        throw error;
      }),
      map((response) => response)
    );

  return componentDataSourceService.updateStoreData(request$, 'rooms').pipe(
    tap(() => {
      refreshAllLocationTableStores(componentDataSourceService);
      notifyDunaLocationsAdminFormSuccess();
    })
  );
}
